import { ENV } from 'configs/constants';
import Settings from 'configs/Settings';

const HOTMART_WEBINAR_URLS = {
  [ENV.LOCAL]: 'https://app-live-admin.buildstaging.com',
  [ENV.STAGING]: 'https://app-live-admin.buildstaging.com',
  [ENV.PRODUCTION]: 'https://live-admin.play.hotmart.com'
};

export const getHotmartWebinarUrl = (webinarKey, isOnlineEvent) => {
  const url = HOTMART_WEBINAR_URLS[Settings.environment];

  if (!webinarKey) {
    return url;
  }

  return `${url}/transmission/${webinarKey}?referer=club${
    isOnlineEvent ? '&online_event=true' : ''
  }`;
};
